import { Row, Col, Button } from "antd";
import { useState, useCallback, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { HelpModal } from "../../HelpModal";
import { useLogoRedirectPath } from "../../../lib/hooks/useLogoRedirectPath";
import MetaService from "../../../services/meta";
import "./styles.scss";

export const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const { logoRedirectPath } = useLogoRedirectPath();

  const openHelp = useCallback(() => setIsModalOpen(true), []);

  const logo: string = useMemo(() => MetaService.logoUrl(false), []);

  return (
    <>
      <Row
        className="guest-header justify-space-between mx-auto"
        align="middle"
      >
        <Link to={logoRedirectPath}>
          <img
            src={logo}
            alt="logo"
            className="logo-cursor"
            style={{ height: "32px" }}
          />
        </Link>
        <Row justify="end">
          <Col>
            <Button
              type="link"
              className="useful-link z-10 px-0"
              onClick={openHelp}
            >
              Help
            </Button>

            <HelpModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
          </Col>
        </Row>
      </Row>

      <Outlet />
    </>
  );
};
